import { Link, useLocation } from "react-router";
import { isAiAvailable } from "../lib/api-modules/ai.js";

/**
 * Floating "Ask Hearth" button — fixed bottom-right (z-50). Hidden when:
 *   (a) AI chat stream URL is missing (Phase 8.1 not deployed yet)
 *   (b) the user is already on /ai* (avoid the button-on-its-own-page
 *       look)
 *
 * Composed from token-driven utilities; no design-system primitive
 * exists for FAB yet (deferred to Phase 8.2 when the staging-inbox
 * also wants one).
 */
export function AiButton() {
  const location = useLocation();
  if (!isAiAvailable()) return null;
  if (location.pathname.startsWith("/ai")) return null;

  return (
    <Link
      to="/ai"
      title="Ask Hearth"
      aria-label="Ask Hearth"
      className="fixed bottom-6 right-6 z-50 flex size-14 items-center justify-center rounded-full font-medium shadow-[var(--shadow-elevated)] transition-transform hover:scale-105"
      style={{
        backgroundColor: "var(--color-accent)",
        color: "var(--color-accent-contrast)",
      }}
    >
      <svg
        viewBox="0 0 24 24"
        className="size-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12a9 9 0 1 1-3.7-7.3L21 3v5h-5" />
        <path d="M12 8v4l3 2" />
      </svg>
    </Link>
  );
}
